import React from 'react';
import { createPortal } from 'react-dom';
import NewEvent from '../../calendar/components/NewEvent';

export function CalendarEventOverlay({ event, portalTarget, user, onClose, onSave, onDelete }) {
    if (!event) return null;

    return createPortal(
        <div className={`task-panel-overlay standalone`} onClick={onClose}>
            <div
                className="task-panel-container"
                onClick={(e) => e.stopPropagation()}
                style={{ width: '450px', display: 'block', padding: '0', overflowY: 'auto', overflowX: 'hidden', position: 'relative' }}
            >
                <div style={{ height: '100%', width: '100%' }}>
                    <NewEvent
                        isOpen={true}
                        onClose={onClose}
                        initialData={event}
                        onSave={onSave}
                        onDelete={onDelete}
                        user={user}
                    />
                </div>
            </div>
        </div>,
        portalTarget
    );
}
